import React, { useState } from "react";
import { LoadingButton } from "../../../components/LoadingButton";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { useTableContext } from "../../components/AdministrateTable";
import { useDestroyPermission } from "../../utils";

export const PayorPolicyActionCell = ({ payorId, ...row }) => {
  const [canDestroy] = useDestroyPermission("Policy", row.original.id);
  const [removing, setRemoving] = useState(false);
  const { refresh, setMessage, setError } = useTableContext();

  const handleRemovePayor = async () => {
    setRemoving(true);
    try {
      const { data } = await api.delete(`/admin/policies/${row.original.id}/payors`, { params: { payor_ids: [payorId] } });
      refresh();
      setMessage(data.meta.message);
    } catch (err) {
      setError(extractErrorMessage(err));
    } finally {
      setRemoving(false);
    }
  };

  return (
    canDestroy && (
      <LoadingButton loading={removing} color="link" className="text-danger" onClick={handleRemovePayor}>
        Remove
      </LoadingButton>
    )
  );
};
